import React, { useEffect, useState } from "react";
import { Button, Input, Space } from "antd";
import { ReactSVG } from "react-svg";
import { Link } from "react-router-dom";
import { filter, isEmpty } from "lodash";
import moment from "moment";

import DriversRoutePlanTable from "../Table/DriversRoutePlan";

import { DATE_FORMAT_FRONTEND } from "../../constants";
import { getTranslation } from "../../utils/helper";

const PAGE_SIZE = 100;

const RoutePlanDrivers = ({
  id,
  routePlan,
  routes,
  doRemoveDriversRoutePlan,
  doDetailRoutePlan,
  onClickRoute,
  doEditDriver,
  setting,
}) => {
  const [searchValue, setSearchValue] = useState(null);
  const [searchedRoutes, setSearchedRoutes] = useState([]);
  const [queryDrivers, setQueryDrivers] = useState({});
  const [loading, setLoading] = useState(false);
  const [modifying, setModifying] = useState(false);

  const currentPage = Number(queryDrivers.currentPage) || 1;
  const itemsPerPage = Number(queryDrivers.itemsPerPage) || PAGE_SIZE;
  const pagination = {
    current: currentPage,
    pageSize: itemsPerPage,
    showTotal: total => `${total} ${getTranslation(setting, "Drivers", "Drivers")}`,
  };

  useEffect(() => {
    setSearchedRoutes(routes);
  }, [routes]);

  useEffect(() => {
    let routesT = routes;
    if (!isEmpty(searchValue)) {
      routesT = filter(routes, o => {
        return (
          o.driver.name?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.driver.phone?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.driver.startLocation?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.shiftStart?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.shiftEnd?.toString().toLowerCase().match(searchValue.toLowerCase()) ||
          o.status?.toString().toLowerCase().match(searchValue.toLowerCase())
        );
      });
    }
    setSearchedRoutes(routesT);
  }, [searchValue]);

  const handleOnSearch = e => {
    setLoading(true);
    setTimeout(() => {
      setSearchValue(e.target.value);
      setLoading(false);
    }, 100);
  };

  const handleBulkUpdate = selectedRoutes => {
    return {
      title:
        selectedRoutes.length > 0
          ? `${selectedRoutes.length} ${getTranslation(setting, "Route Plans", "drivers selected")}`
          : "",
      actions: (
        <Space>
          {selectedRoutes.length > 0 && (
            <Button
              className="btn-add-to-route"
              size="large"
              key="RemoveFromRoute"
              onClick={() => handleRemoveDrivers(selectedRoutes)}
              type="primary">
              {getTranslation(setting, "Common", "Remove")}
            </Button>
          )}
        </Space>
      ),
    };
  };

  const handleRemoveDrivers = async selectedRoutes => {
    setModifying(true);
    await doRemoveDriversRoutePlan({
      id: id,
      drivers: selectedRoutes.map(s => s._id),
    });
    await doDetailRoutePlan(id);
    setModifying(false);
  };

  const onClickRowRoute = record => {
    return {
      onClick: () => {
        onClickRoute(record);
      },
    };
  };

  const handleTableChange = params => {
    setLoading(true);
    setTimeout(() => {
      setQueryDrivers(params);
      setLoading(false);
    }, 100);
  };

  const reloadData = () => {
    doDetailRoutePlan(id);
  };

  const handleUpdateDriver = params => {
    doEditDriver({ id, ...params });
  };

  return (
    <div className="RoutePlanDrivers">
      <div className="MainLeft__Header">
        <div className="MainLeft__Header__Title">
          <Link to="/route-plans">{getTranslation(setting, "Route Plans", "Route Plans")}</Link>
          <ReactSVG className="icon" src="/icons/arrow-forward.svg" />
          <span className="Link">
            {routePlan?.name} (
            <span className="Capitalize">
              {moment(routePlan?.deliveryDate).utc().locale(setting.systemLanguage).format(DATE_FORMAT_FRONTEND)}
            </span>
            )
          </span>
        </div>
        <div className="MainLeft__Header__Search">
          <Input.Search size="large" placeholder="Search Anything" onChange={handleOnSearch} />
          <Link to={`/route-plans/${id}/add-drivers`}>
            <Button size="large" className="NewButton" type="primary">
              {getTranslation(setting, "Route Plans", "Add Drivers")}
              <ReactSVG className="icon" src="/icons/add.svg" />
            </Button>
          </Link>
        </div>
      </div>
      <DriversRoutePlanTable
        rowKey="_id"
        pagination={pagination}
        dataSource={searchedRoutes}
        scrollHeight="calc(100vh - 398px)"
        bulkUpdate={handleBulkUpdate}
        onRow={onClickRowRoute}
        onChange2={handleTableChange}
        query={queryDrivers}
        loading={loading}
        modifying={modifying}
        handleUpdateDriver={handleUpdateDriver}
        reloadData={reloadData}
        setting={setting}
      />
    </div>
  );
};

export default RoutePlanDrivers;
